"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const application_logger_1 = require("./application-logger");
const constants_1 = require("./constants");
// TODO: change this to a class with methods instead of something that returns a function
function initPoller(intervalMs, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback, options) {
    let stopped = false;
    let failedAttempts = 0;
    let nextPollMs = intervalMs;
    let previousPollFailed = false;
    let nextTimer = undefined;
    const start = async () => {
        var _a;
        stopped = false;
        let startRequestSuccess = false;
        let startAttemptsRemaining = 1 + ((_a = options === null || options === void 0 ? void 0 : options.maxStartRetries) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_INITIAL_CONFIG_REQUEST_RETRIES);
        let startErrorToThrow = null;
        while (!startRequestSuccess && startAttemptsRemaining > 0) {
            try {
                await callback();
                startRequestSuccess = true;
                previousPollFailed = false;
                application_logger_1.logger.info('Eppo SDK successfully requested initial configuration');
            }
            catch (pollingError) {
                previousPollFailed = true;
                application_logger_1.logger.warn(`Eppo SDK encountered an error with initial poll of configurations: ${pollingError.message}`);
                if (--startAttemptsRemaining > 0) {
                    const jitterMs = randomJitterMs(intervalMs);
                    application_logger_1.logger.warn(`Eppo SDK will retry the initial poll again in ${jitterMs} ms (${startAttemptsRemaining} attempts remaining)`);
                    await new Promise((resolve) => setTimeout(resolve, jitterMs));
                }
                else {
                    if (options === null || options === void 0 ? void 0 : options.pollAfterFailedStart) {
                        application_logger_1.logger.warn('Eppo SDK initial poll failed; will attempt regular polling');
                    }
                    else {
                        application_logger_1.logger.error('Eppo SDK initial poll failed. Aborting polling');
                        stop();
                    }
                    if (options === null || options === void 0 ? void 0 : options.errorOnFailedStart) {
                        startErrorToThrow = pollingError;
                    }
                }
            }
        }
        const startRegularPolling = !stopped &&
            ((startRequestSuccess && (options === null || options === void 0 ? void 0 : options.pollAfterSuccessfulStart)) ||
                (!startRequestSuccess && (options === null || options === void 0 ? void 0 : options.pollAfterFailedStart)));
        if (startRegularPolling) {
            application_logger_1.logger.info(`Eppo SDK starting regularly polling every ${intervalMs} ms`);
            nextTimer = setTimeout(poll, intervalMs);
        }
        else {
            application_logger_1.logger.info(`Eppo SDK will not poll for configuration updates`);
        }
        if (startErrorToThrow) {
            application_logger_1.logger.info('Eppo SDK rethrowing start error');
            throw startErrorToThrow;
        }
    };
    const stop = () => {
        if (!stopped) {
            stopped = true;
            if (nextTimer) {
                clearTimeout(nextTimer);
            }
            application_logger_1.logger.info('Eppo SDK polling stopped');
        }
    };
    async function poll() {
        var _a;
        if (stopped) {
            return;
        }
        try {
            await callback();
            // If no error, reset any retrying
            failedAttempts = 0;
            nextPollMs = intervalMs;
            if (previousPollFailed) {
                previousPollFailed = false;
                application_logger_1.logger.info('Eppo SDK poll successful; resuming normal polling');
            }
        }
        catch (error) {
            previousPollFailed = true;
            application_logger_1.logger.warn(`Eppo SDK encountered an error polling configurations: ${error.message}`);
            const maxTries = 1 + ((_a = options === null || options === void 0 ? void 0 : options.maxPollRetries) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_POLL_CONFIG_REQUEST_RETRIES);
            if (++failedAttempts < maxTries) {
                const failureWaitMultiplier = Math.pow(2, failedAttempts);
                const jitterMs = randomJitterMs(intervalMs);
                nextPollMs = failureWaitMultiplier * intervalMs + jitterMs;
                application_logger_1.logger.warn(`Eppo SDK will try polling again in ${nextPollMs} ms (${maxTries - failedAttempts} attempts remaining)`);
            }
            else {
                application_logger_1.logger.error(`Eppo SDK reached maximum of ${failedAttempts} failed polling attempts. Stopping polling`);
                stop();
            }
        }
        setTimeout(poll, nextPollMs);
    }
    return {
        start,
        stop,
    };
}
exports.default = initPoller;
/**
 * Compute a random jitter as a percentage of the polling interval.
 * Will be (5%,10%) of the interval assuming POLL_JITTER_PCT = 0.1
 */
function randomJitterMs(intervalMs) {
    const halfPossibleJitter = (intervalMs * constants_1.POLL_JITTER_PCT) / 2;
    // We want the randomly chosen jitter to be at least 1ms so total jitter is slightly more than half the max possible.
    // This makes things easy for automated tests as two polls cannot execute within the maximum possible time waiting for one.
    const randomOtherHalfJitter = Math.max(Math.floor((Math.random() * intervalMs * constants_1.POLL_JITTER_PCT) / 2), 1);
    return halfPossibleJitter + randomOtherHalfJitter;
}
//# sourceMappingURL=poller.js.map